<script>
    import { sgettext } from '../../../i18n.js';

    export let classes = '';
    export let title = '';
    export let processing = false;
</script>


<div class="icon-button">    
    {#if processing}
    <div class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">{sgettext('$$PROCESSING$$')}...</span>
    </div>
    {:else}
    <i 
        class={classes} 
        {title}
        on:click
        />
    {/if}
</div>